(function () {
  const scrollers = document.querySelectorAll('.wp-block-mp-on-scroll-layout .cbp-so-scroller');
  if (!scrollers.length) return;

  const prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  scrollers.forEach((scroller) => {
    // Respeita o toggle global de animação do container
    const animEnabled = scroller.getAttribute('data-animation') !== '0' && !prefersReduced;

    const sections = Array.from(scroller.querySelectorAll('.cbp-so-section'));
    if (!sections.length) return;

    if (!animEnabled) {
      // Garante que tudo é visível — não aplica init nem observe
      sections.forEach((el) => {
        el.classList.remove('cbp-so-init', 'cbp-so-animate');
      });
      return;
    }

    const vfAttr = scroller.getAttribute('data-viewport-factor');
    const viewportFactor = vfAttr ? Math.max(0, Math.min(1, parseFloat(vfAttr))) : 0.2;

    sections.forEach((el) => {
      el.classList.add('cbp-so-init');
      el.classList.remove('cbp-so-animate');
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const el = entry.target;
          if (entry.isIntersecting) {
            el.classList.add('cbp-so-animate');
            el.classList.remove('cbp-so-init');
          } else {
            el.classList.add('cbp-so-init');
            el.classList.remove('cbp-so-animate');
          }
        });
      },
      { threshold: viewportFactor }
    );

    sections.forEach((el) => observer.observe(el));
  });
})();